import { Check } from "lucide-react";

import { IconProps } from "./icon-types";

export const CheckIcon = ({
  width = 20,
  height = 20,
  className,
  ...props
}: IconProps) => {
  return (
    <Check
      width={width}
      height={height}
      className={className}
      strokeWidth={1}
      {...props}
    />
  );
};
